import React, { useEffect, useState } from "react";
import { Star, ArrowUpRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import GoogleRatingBadge from "@/components/GoogleRatingBadge";
import { fetchReviews } from "@/lib/api";
import { SITE } from "@/lib/site";

export const ReviewsSection = () => {
 const [reviews, setReviews] = useState([]);
 useEffect(() => {
 fetchReviews().then(setReviews).catch(() => setReviews([]));
 }, []);

 return (
 <section className="bg-white border-t border-[#EAEAEA]" data-testid="reviews-section">
 <div className="max-w-[1280px] mx-auto px-5 md:px-8 py-20 md:py-28">
 <Reveal>
 <div className="flex flex-wrap items-end justify-between gap-8">
 <div className="max-w-2xl">
 <div className="text-[11px] uppercase tracking-[0.24em] font-bold text-[#4A4A4A]">
 What founders say
 </div>
 <h2 className="mt-4 font-display text-[36px] md:text-[52px] leading-[1.05] font-black tracking-tight text-[#0F1115]">
 Trusted by real founders <br className="hidden md:block" />
 backed by <span className="hl-yellow">Google Reviews</span>.
 </h2>
 </div>
 <GoogleRatingBadge testId="reviews-section-google-badge" />
 </div>
 </Reveal>

 <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
 {reviews.map((r, i) => (
 <Reveal delay={i * 80} key={r.id}>
 <div className="h-full bg-white border border-[#EAEAEA] rounded-2xl p-7 flex flex-col" data-testid={`review-card-${r.id}`}>
 <div className="flex text-[#FDD805] mb-4">
 {Array.from({ length: r.rating }).map((_, i2) => (
 <Star key={i2} size={16} fill="#FDD805" strokeWidth={0} />
 ))}
 </div>
 <p className="text-[15.5px] leading-relaxed text-[#0F1115]">
 "{r.text}"
 </p>
 <div className="mt-6 pt-4 border-t border-[#EAEAEA] flex items-center justify-between">
 <div>
 <div className="font-bold text-[14px] text-[#0F1115]">{r.name}</div>
 <div className="text-[12px] text-[#4A4A4A]">{r.role}</div>
 </div>
 <div className="text-[11px] text-[#4A4A4A]">{r.date}</div>
 </div>
 </div>
 </Reveal>
 ))}
 </div>

 <Reveal delay={80}>
 <div className="mt-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 border-t border-[#EAEAEA] pt-10">
 <p className="text-[15px] text-[#1C1F26] max-w-xl">
 This is a small sample of {SITE.googleReviewCount} verified reviews from real founders on Google.
 </p>
 <a
 href={SITE.googleReviewsUrl}
 target="_blank"
 rel="noreferrer noopener"
 className="inline-flex items-center gap-2 bg-[#0F1115] text-white rounded-full px-6 py-3 font-bold text-[14px] hover:bg-[#1c1f26] transition-colors"
 data-testid="reviews-read-all-google-cta"
 >
 Read all {SITE.googleReviewCount} reviews on Google <ArrowUpRight size={15} />
 </a>
 </div>
 </Reveal>
 </div>
 </section>
 );
};

export default ReviewsSection;
